import * as React from 'react'
import styles from './styles.module.css'

export const Group = ({
  className = '',
  ...props
}: React.ComponentProps<'div'>) => (
  <div {...props} className={styles.group + ' ' + className} />
)
